import { css } from 'aphrodite';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { Dropdown, DropdownContent, DropdownItem, DropdownTrigger } from '../../../web/components-v2/Dropdown';
import { Avatar } from '@HoudiniUI/Avatar';
import { getAvatarProps } from '@AppModels/AvatarUtils';
import { DisclosureIcon } from '../../../web/components/svgs/icons/DisclosureIcon';
import { IntegrationIcon } from '../../../web/components/svgs/icons/IntegrationIcon';
import { LogoutIcon } from '../../../web/components/svgs/icons/LogoutIcon';
import { QuestionMarkIcon } from '../../../web/components/svgs/icons/QuestionMarkIcon';
import { ReportingIcon } from '../../../web/components/svgs/icons/ReportingIcon';
import { SettingsIcon } from '../../../web/components/svgs/icons/SettingsIcon';
import { brandPrimaryLight, grayIconFill } from '../../styles/colors';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
}

export const UserOptions: React.FC<IProps> = ({ className = '' }) => {
	const userSession = useUserSession();
	const history = useHistory();

	const isPropertyMappingEnabled = userSession?.account?.features?.aida?.propertyMappingEnabled;

	return (
		<div className={`${css(styleSheet.userOptionsContainer)} ${className}`}>
			<Dropdown>
				<DropdownTrigger className={css(styleSheet.select)}>
					<div className={css(styleSheet.anchor)}>
						<Avatar {...getAvatarProps(userSession.user)} styles={[styleSheet.avatar]} />
						<DisclosureIcon type='chevron' fillColor={brandPrimaryLight} className={css(styleSheet.chevron)} />
					</div>
				</DropdownTrigger>
				<DropdownContent>
					<DropdownItem onClick={() => history.push('/settings')} styles={[styleSheet.optionStyles]}>
						<div className={css(styleSheet.optionContent)}>
							<SettingsIcon stroke={grayIconFill} className={css(styleSheet.iconSize)} />
							Settings
						</div>
					</DropdownItem>
					<DropdownItem onClick={() => window.open('https://help.coffee.inc')} styles={[styleSheet.optionStyles]}>
						<div className={css(styleSheet.optionContent)}>
							<QuestionMarkIcon fillColor={grayIconFill} className={css(styleSheet.iconSize)} />
							Help
						</div>
					</DropdownItem>
					<DropdownItem onClick={() => history.push('/reporting')} styles={[styleSheet.optionStyles]}>
						<div className={css(styleSheet.optionContent)}>
							<ReportingIcon className={css(styleSheet.iconSize)} />
							Reporting
						</div>
					</DropdownItem>
					{isPropertyMappingEnabled && (
						<DropdownItem onClick={() => history.push('/integration')} styles={[styleSheet.optionStyles]}>
							<div className={css(styleSheet.optionContent)}>
								<IntegrationIcon fill={grayIconFill} />
								Integration
							</div>
						</DropdownItem>
					)}
					<DropdownItem onClick={() => history.push('/logout')} styles={[styleSheet.optionStyles]}>
						<div className={css(styleSheet.optionContent)}>
							<LogoutIcon fill={grayIconFill} className={css(styleSheet.iconSize)} />
							Logout
						</div>
					</DropdownItem>
				</DropdownContent>
			</Dropdown>
		</div>
	);
};
